// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__KLgLy","actionsCol":"EnrolledClinics_actionsCol__26nrl"};